import { REPORT_TYPES } from './constants'

export const useCalculatorSummary = ({ watch }) => {
  const getFormattedValue = (name, max) => {
    const value = watch(name)

    if (name === 'consultation_quantity') {
      return `${value || max / 2} consultas`
    }

    if (name === 'consultation_type') {
      if (!value) return '--'

      return value === 'cpf_cnpj' ? 'CPF e CNPJ' : value.toUpperCase()
    }

    if (name === 'negativation_quantity') {
      return `${value || max / 2} serviços`
    }

    return REPORT_TYPES[value] || '--'
  }

  return {
    getFormattedValue
  }
}
